import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
const routes=[
    
    {
        path: '/',
        components: {
            default: () => import('@/views/pc/index'),
            pc: () => import('@/views/pc/index'),
            m: () => import('@/views/move/index'),
        },
        meta:{title:'嘉贸收银台'}
    },
   
   


]

export default new Router({
    mode: 'history',
    routes
})